// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Anwesenheit, AnwesenheitDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useApproveAnwesenheit(): (
  anwesenheitId: string,
  requestBody: AnwesenheitDaten
) => Promise<Anwesenheit> {
  const getAPI = useGetApi();
  return useCallback(
    async (anwesenheitId, requestBody) =>
      (await getAPI()).anwesenheiten.approveAnwesenheit({
        anwesenheitId,
        requestBody,
      }),
    [getAPI]
  );
}
